// Import the functions you need from the SDKs you need
import { initializeApp } from "@firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCNdiK6BjgeToOv6zZSwJrLCRWe02dIf_U",
  authDomain: "fiverrrms1.firebaseapp.com",
  databaseURL: "https://fiverrrms1-default-rtdb.firebaseio.com",
  projectId: "fiverrrms1",
  storageBucket: "fiverrrms1.appspot.com",
  messagingSenderId: "867766127997",
  appId: "1:867766127997:web:8afddf3d90c7793eb01014"
};

export default firebaseConfig;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app, "northamerica-northeast1");
const auth = getAuth(app);
const storage = getStorage(app);

// No offline persistence needed for super admin app (web-only)
export { auth, db, functions, storage };

